"use client"
import React, { useCallback, useRef, useState } from "react";
import { Autoplay, Grid, Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/grid";
import "swiper/css/navigation";
import { useModalDispatch } from "@/context/ModalContext";
import { IModalActions, ModalTypes } from "@/types/modal";

import styles from "./TransformingTalentAcrossIndustries.module.scss";
import { Swiper, SwiperSlide } from "swiper/react";

const content = [
  {
    image: "https://amityonline.com/_v5/8986fa198c5ebdd2b12c96ce231d4c92d1553fab_cff7ad7fff.webp",
    heading: "ACCR",
    subtextHeading: "Leading Roles:",
    subtext: "Making students career-ready with industry-recognised certifications.",
    bgColor:"linear-gradient(0deg, rgba(0, 24, 93, 0.6) 0%, rgba(0, 0, 0, 0) 100%),linear-gradient(0deg, rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6))"

  },
  {
    image: "https://amityonline.com/_v5/fe4680d85ea9275e064c84957216c8a3d370c3f4_1_9d0ffa7670.webp",
    heading: "Workshops & Master Classes",
    subtextHeading: "Leading Roles:",
    subtext: "Empowering learners with practical skills through engaging workshops and expert-led masterclasses.",
    bgColor:"linear-gradient(180deg, rgba(0, 0, 0, 0.5) 0%, rgba(126, 42, 12, 0.5) 100%)"
  },
  {
    image: "https://amityonline.com/_v5/fe4680d85ea9275e064c84957216c8a3d370c3f4_1_9d0ffa7670.webp",
    heading: "Industry Connect & Networking",
    subtextHeading: "Leading Roles:",
    subtext: "Providing learners with exposure to real-world business environments.",
    bgColor:"linear-gradient(180deg, rgba(0, 0, 0, 0.4) 0%, rgba(0, 93, 71, 0.4) 100%)"
  },
  {
    image: "https://amityonline.com/_v5/fe4680d85ea9275e064c84957216c8a3d370c3f4_1_9d0ffa7670.webp",
    heading: "Exclusive Job Opportunities",
    subtextHeading: "Leading Roles:",
    subtext: "Providing learners with exposure to real-world business environments.",
    bgColor:"linear-gradient(180deg, rgba(0, 0, 0, 0.7) 0%, rgba(5, 70, 179, 0.7) 100%)"
  },
  {
    image: "https://amityonline.com/_v5/fe4680d85ea9275e064c84957216c8a3d370c3f4_1_9d0ffa7670.webp",
    heading: "Direct Interview Opportunities",
    subtextHeading: "Leading Roles:",
    subtext: "Providing learners with exposure to real-world business environments.",
    bgColor:"linear-gradient(180deg, rgba(0, 0, 0, 0.7) 0%, rgba(131, 104, 0, 0.7) 100%)"
  },
  {
    image: "https://amityonline.com/_v5/fcd83b015e9c33390da78a4791dc1de1ad8c057f_efd62a9659.webp",
    heading: "AI Powered Employability Tools",
    subtextHeading: "Leading Roles:",
    subtext: "Making students career-ready with industry-recognised certifications.",
    bgColor:"linear-gradient(180deg, rgba(0, 0, 0, 0.5) 0%, rgba(126, 42, 12, 0.5) 100%)"
  },
  {
    image: "https://amityonline.com/_v5/fe4680d85ea9275e064c84957216c8a3d370c3f4_1_9d0ffa7670.webp",
    heading: "Personalised Job Matching",
    subtextHeading: "Leading Roles:",
    subtext: "Empowering learners with practical skills through engaging workshops and expert-led masterclasses.",
    bgColor:"linear-gradient(180deg, rgba(0, 0, 0, 0.8) 0%, rgba(12, 96, 126, 0.8) 100%)"
  },
  {
    image: "https://amityonline.com/_v5/fe4680d85ea9275e064c84957216c8a3d370c3f4_1_9d0ffa7670.webp",
    heading: "Placement Readiness Support",
    subtextHeading: "Leading Roles:",
    subtext: "Providing learners with exposure to real-world business environments.",
    bgColor:"linear-gradient(180deg, rgba(0, 0, 0, 0.5) 0%, rgba(45, 179, 5, 0.5) 100%)"
  },
  {
    image: "https://amityonline.com/_v5/fe4680d85ea9275e064c84957216c8a3d370c3f4_1_9d0ffa7670.webp",
    heading: "Career Mentoring",
    subtextHeading: "Leading Roles:",
    subtext: "Providing learners with exposure to real-world business environments.",
    bgColor:"linear-gradient(180deg, rgba(0, 0, 0, 0.7) 0%, rgba(131, 104, 0, 0.7) 100%)"
  },
  {
    image: "https://amityonline.com/_v5/fe4680d85ea9275e064c84957216c8a3d370c3f4_1_9d0ffa7670.webp",
    heading: "Dedicated Placement Assistance",
    subtextHeading: "Leading Roles:",
    subtext: "Providing learners with exposure to real-world business environments.",
    bgColor:"linear-gradient(180deg, rgba(0, 0, 0, 0.7) 0%, rgba(131, 0, 31, 0.7) 100%)"
  }
];

export default function TransformingTalentAcrossIndustries({associatedPrograms,isMobile=false}) {
     const [isAtStart, setIsAtStart] = useState(true);
      const [isAtEnd, setIsAtEnd] = useState(false);
      const sliderRef = useRef(null);
  const handleSlideChange = (swiper) => {
    setIsAtStart(swiper.isBeginning);
    setIsAtEnd(swiper.isEnd);
  };
  const modalDispatch = useModalDispatch();

  const handleBtnClicked = () => {
  modalDispatch({
    type: IModalActions.OpenModal,
    data: {
      modalType: ModalTypes.ConnectModalV2,
      modalData: {
        heading: "Get career guidance designed for your goals",
        submitBtnText: "Book a Free Session",
        associatedPrograms,
        isLandingPage: true,
      },
    },
  });
  }
  return (
      <div className={styles.container}>
        <div className={styles.testimonialsSection}>
          <h3>Job Readiness Initiatives For Our Students </h3>

          <div className={styles.gridContainer}>
            <Swiper
              ref={sliderRef}
              modules={[Grid, Pagination, Autoplay, Navigation]}
              navigation={true}
              pagination={{ clickable: true }}
              // autoplay={{ delay: 5000}}
              slidesPerView={6}
              className="Carousel__blueBullet Carousel__hAuto"
              grid={{
                rows: 2,
                fill: "row",
              }}
              breakpoints={{
                320: {
                  slidesPerView: 2,
                  grid: { rows: 5, fill: "row" },
                  spaceBetween: 1,
                },
                768: {
                  slidesPerView: 4,
                  grid: { rows: 2, fill: "row" },
                  spaceBetween: 16,
                },
                1024: {
                  slidesPerView: 5,
                  grid: { rows: 2, fill: "row" },
                  spaceBetween: 16,
                },
              }}
              onSlideChange={handleSlideChange}
              onReachBeginning={() => setIsAtStart(true)}
              onReachEnd={() => setIsAtEnd(true)}
            >
              {content.map(
                ({ image, heading, subtextHeading, subtext, bgColor }, index) => (
                  <SwiperSlide key={index}>
                <div className={styles.perGrid} key={subtext}>
                  <div className={styles.flipCard}>
                    <div
                      className={styles.flipCardFront}
                      style={{ backgroundImage: `url(${image})` }}
                    >
                      <div
                        className={styles.overlay}
                        style={{ "--card-overlay": bgColor } as React.CSSProperties}
                      />

                      <div className={styles.content}>
                        <div className={styles.heading}>{heading}</div>

                        <div className={styles.subtext}>
                          {subtext}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                  </SwiperSlide>
                )
              )}
            </Swiper>
          </div>
          {!isMobile && <button onClick={handleBtnClicked} className={styles.ctaButton}>
          Schedule a Free Career Counselling → 
          </button>}
          
        </div>
    </div>
  );
}
